import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./Routes";
import Layout from "../Layout/Layout";
import { hasPermission } from "../Shared/Utils/userUtils";
import Unauthorized from "../Shared/Pages/Unauthorized";

const LayoutRoutes = () => {
  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component, permission }, i) => (
          <Route element={<Layout />} key={i}>
            {hasPermission(permission) ? (
              <Route path={path} element={Component} />
            ) : (
              <Route path={path} element={<Unauthorized />} />
            )}
          </Route>
        ))}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
